/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/DropdownList';
import TimePickerHour from 'app/components/common/TimePickerHour.jsx';
import TimePickerMinute from 'app/components/common/TimePickerMinute.jsx';
import TimePickerMeridiem from 'app/components/common/TimePickerMeridiem.jsx';
import CategoryItem from 'app/components/DropDownItems/CategoryItem.jsx';
import DayPicker from 'app/components/common/DayPicker.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class NewScheduleControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: 0x7f,
            category: 0,
            time: null
        };

        this.setDays = this.setDays.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onAddSchedule = this.onAddSchedule.bind(this);

    }

    componentDidMount() {
        let time = new moment();

        if (this.props.user && this.props.user.detail.timezone) {
            time = moment().tz(this.props.user.detail.timezone);
        }

        this.setState({
            time
        });

    }

    componentDidUpdate(prevProps, prevState) {

        let time = new moment();

        if (this.props.user && this.props.user.detail.timezone) {
            time = moment().tz(this.props.user.detail.timezone);
        }

        if (this.props.reset) {
            this.setState({
                days: 0x7f,
                category: 0,
                time
            });
        }

    }

    componentWillUnmount() {
        this.props.deleteApiError(['SOCIAL_UPDATE']);
    }

    setDays(e) {
        let days = this.state.days,
            day = parseInt(e.currentTarget.dataset.day);

        if (day & days) {
            days = days ^ day;
        } else {
            days = days | day;
        }

        this.setState({
            days
        });
    }

    onCategoryChange(category) {

        this.setState({
            category: category.id
        });

    }

    onTimeChange(value, e) {

        let time = moment(this.state.time);

        switch (e.currentTarget.dataset.field) {
            case "hours":
                time.tz(this.props.user.detail.timezone);
                time.hour(value);
                break;

            case "minutes":
                time.minute(value);
                break;

            case "meridiem":
                if (time.hour() > 12 && value === 'AM') {
                    time.subtract(12, 'hours');
                } else if (time.hour() < 12 && value === 'PM') {
                    time.add(12, 'hours');
                } else {
                    if (value === 'AM') {
                        time.hour(0);
                    } else {
                        time.hour(12);
                    }
                }
                break;

            default:
                break;
        }

        this.setState({
            time
        });

    }

    onAddSchedule(e) {
        let data = {};

        e.preventDefault();

        data = _.clone(this.state);
        data.social = this.props.social;
        data.time = data.time.format('HH:mm:00');

        // clear out any old errors
        this.props.deleteApiError(['SOCIAL_UPDATE']);

        this.props.addNewSchedule(data, e);

    }

    render() {
        let headline = null,
            categoryList = _.clone(this.props.categoryList),
            disabled = false,
            categoryOnClick = null,
            constants = this.props.app.config.constants;

        if (this.props.user.perms.resources && !this.props.user.perms.resources.categories) {
            disabled = true;
            categoryOnClick = this.props.onCategoryUpgrade;
        }

        // Only a schedule conflict has copy of its own, so any other SOCIAL_UPDATE failure (a
        // network error, say) keeps the heading rather than showing an empty error block.
        if (this.props.socialError !== null && this.props.socialError.errors?.validation?.sched) {
            headline = (
                <div className="schedule-error">
                    Say it isn't so, this schedule conflicts with an existing schedule
                </div>
            );
        } else {
            headline = (
                <h2>Create a New Time</h2>
            );
        }

        categoryList.shift();

        return (
            <div className="new-queue-schedule">
                {headline}
                <Breakpoint desktop only>
                    <div className="control-block categories">
                        <div className="category-dropdown" onClick={categoryOnClick}>
                        <DropdownList
                            data={categoryList}
                            dataKey='id'
                            filter={false}
                            renderListItem={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            renderValue={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            placeholder="Choose Category"
                            className="category-drop new-schedule"
                            disabled={disabled}
                            onChange={this.onCategoryChange} />
                        </div>
                    </div>
                    <div className="control-block time">
                        <TimePickerHour
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                        <TimePickerMinute
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                        <TimePickerMeridiem
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                    </div>
                    <div className="control-block days">
                        <DayPicker
                            {...this.props}
                            days={this.state.days}
                            setDays={this.setDays} />
                    </div>
                    <div className="control-block create">
                        <button className="btn-primary fixed active new-schedule" onClick={this.onAddSchedule}>
                            Add
                        </button>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="control-block days">
                        <DayPicker
                            {...this.props}
                            days={this.state.days}
                            setDays={this.setDays} />
                    </div>
                    <div className="control-block time">
                        <TimePickerHour
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                        <TimePickerMinute
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                        <TimePickerMeridiem
                            {...this.props}
                            changeHandler={this.onTimeChange}
                            scheduleTime={this.state.time}
                            id="new" />
                    </div>
                    <div className="control-block categories">
                        <div className="category-dropdown" onClick={categoryOnClick} role="button" aria-label="Show categories">
                        <DropdownList
                            data={categoryList}
                            dataKey='id'
                            filter={false}
                            renderListItem={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            renderValue={({ item }) => {
                                return (
                                    <CategoryItem
                                        item={item}/>
                                );
                            }}
                            placeholder="Choose Category"
                            className="category-drop new-schedule"
                            disabled={disabled}
                            onChange={this.onCategoryChange} />
                        </div>
                    </div>
                    <div className="control-block create">
                        <div className="mobile-cancel-button" onClick={this.props.cancelHandler} role="button" aria-label="cancel">
                            cancel
                        </div>
                        <button className="btn-primary fixed active new-schedule" onClick={this.onAddSchedule} role="button" aria-label="add schedule">
                            Add
                        </button>
                    </div>
                </Breakpoint>
            </div>
        );
    }
}

NewScheduleControl.displayName = "NewScheduleControl";

NewScheduleControl.propTypes = {
    addNewSchedule: PropTypes.func
};

NewScheduleControl.defaultProps = {
    addNewSchedle: () => {}
};

export default NewScheduleControl;
